export enum PasswordResetStatus {
  SENT = 'passwords.sent',
  USER = 'passwords.user',
  RESET = 'passwords.reset',
  THROTTLE = 'passwords.throttle',
}
